import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=7b04f1bb&scoped=true"
import script from "./Opening.vue?vue&type=script&lang=js"
export * from "./Opening.vue?vue&type=script&lang=js"
import style0 from "./Opening.vue?vue&type=style&index=0&id=7b04f1bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b04f1bb",
  null
  
)

export default component.exports